
import Color from "color";

// 定义颜色类型 
// 从 localStorage 获取已保存的颜色或设置默认颜色
const savedColor = localStorage.getItem("themeColor") || "#409eff";
const selectedColor = ref(savedColor);

// 生成从深到浅的颜色梯度
const generateLightColorShades = (baseColor) => {
  const color = Color(baseColor);

  // 生成深到浅的 10 个颜色梯度
  const shades = Array.from({ length: 10 }, (_, i) => {
    return color.mix(Color("white"),   i * 0.1).hex();
  });

  return shades;
};

const generateDarkColorShades = (baseColor) => {
  const color = Color(baseColor);

  // 生成深到浅的 10 个颜色梯度
  const shades = Array.from({ length: 3 }, (_, i) => {
    return color.mix(Color("black"), (i + 1) * 0.1).hex();
  });

  return shades;
};

// 设置 CSS 变量
const setThemeLightColors = (shades ) => {
  shades.forEach((shade, index) => {
    document.documentElement.style.setProperty(
      `--el-color-primary-light-${index}`,
      shade
    );
  });
};

const setThemeDarkColors = (shades) => {
  shades.forEach((shade, index) => {
    document.documentElement.style.setProperty(
      `--el-color-primary-dark-${index}`,
      shade
    );
  });
};

// 更新主题颜色
export const changeTheme = (color) => {
  
  const lightShades = generateLightColorShades(color);
  setThemeLightColors(lightShades);
  const darkShades = generateDarkColorShades(color);
  setThemeDarkColors(darkShades);
  document.documentElement.style.setProperty(`--el-color-primary`, color);

  // 存储颜色到 localStorage
  if(color){
    localStorage.setItem("themeColor", color);
  }else{
    localStorage.removeItem("themeColor");
  }
  
};
